import { useState, useEffect } from "react";
import { accessAPI } from "../../shared";

/**
 * Si el organismo tiene la integración con Penta-Transaction configurada.
 *
 * De esto depende si se muestra algo de importaciones en el home, el perfil
 * de cliente o Gestión — sin la integración no hay datos que puedan aparecer
 * ahí, así que esas secciones ni se montan.
 *
 * Devuelve null mientras no se sabe (para no mostrar nada por un instante), y
 * false si falla el fetch (fail-safe hacia "ocultar").
 */
export default function useConPenta() {
  const [conPenta, setConPenta] = useState(null);

  useEffect(() => {
    accessAPI(
      "GET",
      "admin/importacion/integracion",
      null,
      (respuesta) => setConPenta(Boolean(respuesta.conPenta)),
      () => setConPenta(false)
    );
  }, []);

  return conPenta;
}
